import { RestUrl } from "../../common/cyan.types";

export class EcoaUrl {
  public static getEcoaStudySpec: () => RestUrl = () => ["GET", "/study/ecoa/spec"];
}
